import { useCallback, useRef } from 'react';
import VirtualList, { ItemInfo } from '@components/react-tiny-virtual-list';
import { PseudoEntityRow } from '@data/entity/types';
import useDebouncedResizeObserver from '@hooks/useDebouncedResizeObserver';
import { useVirtualDndContext } from '@providers/DragAndDropProvider';

import { TagsTreeItem } from './TagsTreeItem';

export type TagsTreeProps = {
    items: PseudoEntityRow[];
    isExpanded: (path: string[]) => boolean;
    toggleExpand: (path: string[]) => void;
};

export const TagsTree = (props: TagsTreeProps) => {
    const { items, isExpanded, toggleExpand } = props;
    const { ref, height } = useDebouncedResizeObserver(500, true);

    const innerRef = useRef<VirtualList>(null);
    const { version } = useVirtualDndContext();

    const renderItem = useCallback(
        // added dnd version (which gets incremented after every drop) to rendered item's key
        // this is needed for bypassing dnd-kit bug which makes items undraggable after drop
        ({ index, style }: ItemInfo) => (
            <div key={`${index}-${version}`} style={style}>
                <TagsTreeItem item={items[index]} isExpanded={isExpanded} toggleExpand={toggleExpand} />
            </div>
        ),
        [items, isExpanded, toggleExpand, version]
    );

    return (
        <div ref={ref} style={{ height: '100%', marginLeft: '-10px' }}>
            <VirtualList
                ref={innerRef}
                width={'100%'}
                height={height}
                itemCount={items.length + 1}
                itemSize={28}
                renderItem={renderItem}
                style={{ willChange: 'unset' }}
            />
        </div>
    );
};
